import React, { FC } from 'react'

type ProductListHeaderProps = {
  title: string
  listId: string
}

const ProductListHeader: FC<ProductListHeaderProps> = ({ title, listId }) => (
  <div
    className="sticky fw6 f4 f3-ns ml5 ml0-ns c-on-base mb5-ns mb4-s"
    data-testid={`product-list-title-${listId}`}
  >
    {title}
  </div>
)

export default ProductListHeader
